import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

  html,
  body,
  div,
  span,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  a,
  em,
  img,
  strong,
  form,
  table,
  section {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    box-sizing: border-box;
  }

  section,
  footer,
  header,
  menu,
  nav {
    display: block;
  }

  input,
  textarea,
  select,
  button {
    box-sizing: border-box;
    font-family: inherit;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    font-family: ${({ theme: { font } }) => font.body};
    font-size: ${({ theme: { font } }) => font.main};
    line-height: 1.6;
    color: ${({ theme: { colors } }) => colors.slate[700]};
    background-color: ${({ theme: { colors } }) => colors.pageBg};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme: { font } }) => font.heading};
    color: ${({ theme: { colors } }) => colors.slate[900]};
    line-height: 1.2;
    letter-spacing: -0.01em;
  }

  ol,
  ul {
    list-style: none;
  }

  a, button {
    cursor: pointer;
  }

  a:link {
    text-decoration: none;
  }

  a {
    font-size: inherit;
    text-decoration: none;
    color: inherit;
    transition: color ${({ theme: { transition } }) => transition.fast};
  }

  a:hover {
    color: inherit;
  }

  img {
    max-width: 100%;
  }

  ::selection {
    background-color: ${({ theme: { colors } }) => colors.main.blue};
    color: ${({ theme: { colors } }) => colors.white};
  }

  :focus {
    outline: none;
  }

  :focus-visible {
    outline: 2px solid ${({ theme: { colors } }) => colors.main.blue};
    outline-offset: 2px;
    border-radius: 4px;
  }

  .container {
    max-width: ${({ theme: { layout } }) => layout.maxWidth};
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

`;
